module.exports = __webpack_public_path__ + "img/live4.9038222c.png";